<template>
<div>
    <b-form @submit.prevent="DELRow">
        <b-row>
            <b-col>
                <div class="card-wrapper">
                    <card>
                        <b-row>
                            <b-col sm="4"> NAMA</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{objMaklPer.NamaPegawai}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4"> NO KAD PENGENALAN</b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">{{objMaklPer.NoKP}}
                            </b-col>
                        </b-row>
                        <div class="pl-lg-4">
                            <b-row>
                                <b-col md="12" class="text-md-right">
                                    <b-button variant="danger" @click="batal()">BATAL</b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </card>
                </div>
            </b-col>
        </b-row>
        <!-- </b-container> -->
    </b-form>
</div>
</template>

<script>
import swal from "sweetalert2";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
export default {
    props: {
        kemaskini: {
            type: Object
        },
    },

        data() {
        return {
            objMaklPer: {
                skim: ''
            },
            SenaraiPenjawatAwam: {
                    CONm: "shuk",
                    NoKP: "2000101010101",
                    NoMohon: "M-001",
                    Agensi: "KPM",
                    PegPengira: "AKMAL"
                },
        }},
    methods: {

        batal() {
            this.$emit("batal");
        },
    },
        created() {

        console.log("kemaskini", this.kemaskini);
        let condPenjawatAwam = {
            ICNo: this.kemaskini.ICNo,
            coid: this.kemaskini.coid,
        };

        GetsalaryService.get_MaklLaporanSelesai(this.kemaskini)
            .then((resp) => {
                this.objMaklPer = resp.data[0];
                console.log("objMaklPer", this.objMaklPer);
                //this.objMaklPer.DtLantikanPertama = moment(this.objMaklPer.DtLantikanPertama, "YYYY-MM-DD").format("DD-MM-YYYY");
            })
            .catch((err) => {
                console.log(err);
            });

    },
    computed: {
        
    },
}
</script>
